import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import Checkbox from "./elements/Checkbox"
import Icon from "./elements/Icon"

export default function Facet({ facet }) {
    const { active, selectedFiltersCount, toggleActive, toggleProductFilter } = useFacet(facet)

    const isColorFacet = facet?.field === "customFields.custom-colour_swatch";
    console.log(facet.name, active);

    return (
        <li class={`ns-sidebar-dropdown ${active ? "ns-active" : ""}`}>
            <a
            // ns-p-4
                class={`ns-d-inline-block ns-relative ns-w-100 ns-border-box ns-text-undecorated ${isColorFacet ? 'ns-color-facet-btn' : ''}`}
                href="javascript:void(0)"
                data-nosto-element="facet"
                onClick={toggleActive}
            >
                {/* ns-font-4 */}
                <span class="ns-color-black">{facet.name}</span>
                {/* {selectedFiltersCount > 0 && (
                    <span class="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                        {selectedFiltersCount}
                    </span>
                )} */}
                <Icon name="arrow" className="ns-absolute" />
            </a>
            <div class={`ns-sidebar-submenu ns-d-none ${isColorFacet ? "" : "ns-p-4"}`}>
                <ul class={`ns-list-unstyled ns-p-0 ${isColorFacet ? "ns-color-facet" : "ns-m-0"}`}>
                    {facet.data?.map(value => (
                        // ns-font-3
                        // ns-justify-content-between
                        <li
                        // ns-align-items-center
                            class="ns-d-flex"
                            data-nosto-element="facet-setting"
                        >
                            <Checkbox
                                value={value.value}
                                selected={value.selected}
                                isColorFacet={isColorFacet}
                                onChange={e => {
                                    e.preventDefault()
                                    toggleProductFilter(facet.field, value.value, !value.selected)
                                }}
                            />
                            {/* ns-font-3 ns-font-bold ns-background-grey-light*/}
                            {!isColorFacet && <span class="ns-count ns-d-inline-block ns-text-align-center ns-py-1 ns-px-1 ns-color-black ns-border-radius-3">
                                ({value.count})
                            </span>}
                        </li>
                    ))}
                </ul>
            </div>
        </li>
    )
}
